/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DragDirective } from './drag.directive';
import { SlideToggleComponent } from './slide-toggle.component';

@NgModule({
    exports: [SlideToggleComponent],
    declarations: [
        SlideToggleComponent,
        DragDirective
    ],
    imports: [
        CommonModule
    ]
})
export class SlideToggleModule {

}
